/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */

window.Vue = require('vue');
require('vue-resource');

/**
 * We'll register a HTTP interceptor to attach the "CSRF" header to each of
 * the outgoing requests issued by this application. The CSRF middleware
 * included with Laravel will automatically verify the header's value.
 */

Vue.http.interceptors.push((request, next) => {
    request.headers.set('X-CSRF-TOKEN', Laravel.csrfToken);

    next(response => {
        if (response.status === 401) {
            // Using reload ensures user is returned
            // to current page after logging in again
            window.location.reload();
        }
    });
});

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from "laravel-echo"

if (Laravel.broadcasting && Laravel.broadcasting.driver == "echo") {
    window.Echo = new Echo({
        broadcaster: 'socket.io',
        host: Laravel.broadcasting.serverUrl
    });
}

if (Laravel.broadcasting && Laravel.broadcasting.driver == "pusher") {
    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: Laravel.broadcasting.key,
        cluster: Laravel.broadcasting.options.cluster,
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/shared/bootstrap.js